/**
 * @generated SignedSource<<49a308470936ae8f7f4f8b96658ca975>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type APPROVAL_STATUS = "APPROVED" | "SUBMITTED" | "NOT_SUBMITTED" | "PENDING" | "DECLINED" | "INVOICED" | "%future added value";
export type APPROVAL_TYPE = "SUBMIT_TIME_OFF" | "SUBMIT" | "APPROVE" | "FORCE_APPROVE" | "UNSUBMIT" | "UNAPPROVE" | "RESUBMIT" | "DECLINE" | "REVERSE_APPROVAL" | "INVOICE" | "%future added value";
export type UpdateApprovalStatusInput = {
  personIds?: ReadonlyArray<string | null> | null;
  projectIds?: ReadonlyArray<string | null> | null;
  idleTimeIds?: ReadonlyArray<string | null> | null;
  approvalType?: APPROVAL_TYPE | null;
  startYear?: number | null;
  startMonth?: number | null;
  startDay?: number | null;
  endYear?: number | null;
  endMonth?: number | null;
  endDay?: number | null;
  sendNotification?: boolean | null;
  rejectionMessage?: string | null;
  declineReason?: string | null;
  includeTimeOff?: boolean | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type UpdateApprovalStatusMutation$variables = {
  input: UpdateApprovalStatusInput;
  weekStart?: string | null;
  weekEnd?: string | null;
};
export type UpdateApprovalStatusMutation$data = {
  readonly updateApprovalStatus: {
    readonly timeRegs: ReadonlyArray<{
      readonly id: string;
      readonly approvalStatus: APPROVAL_STATUS | null;
      readonly noApprovalStatusChange: string | null;
      readonly lockedInPeriod: boolean | null;
    } | null> | null;
    readonly persons: ReadonlyArray<{
      readonly id: string;
      readonly submitLockedDateYear: number | null;
      readonly submitLockedDateMonth: number | null;
      readonly submitLockedDateDay: number | null;
      readonly weekApprovals: ReadonlyArray<{
        readonly id: string;
        readonly weekStartYear: number;
        readonly weekStartMonth: number;
        readonly weekStartDay: number;
        readonly approvalStatus: APPROVAL_STATUS;
        readonly declineReason: string | null;
      } | null> | null;
    } | null> | null;
    readonly errors: ReadonlyArray<string | null> | null;
  } | null;
};
export type UpdateApprovalStatusMutation = {
  variables: UpdateApprovalStatusMutation$variables;
  response: UpdateApprovalStatusMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "weekEnd"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "weekStart"
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "approvalStatus",
  "storageKey": null
},
v5 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateApprovalStatusPayload",
    "kind": "LinkedField",
    "name": "updateApprovalStatus",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "TimeRegType",
        "kind": "LinkedField",
        "name": "timeRegs",
        "plural": true,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "noApprovalStatusChange",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lockedInPeriod",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Person",
        "kind": "LinkedField",
        "name": "persons",
        "plural": true,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "submitLockedDateYear",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "submitLockedDateMonth",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "submitLockedDateDay",
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "endDate",
                "variableName": "weekEnd"
              },
              {
                "kind": "Variable",
                "name": "startDate",
                "variableName": "weekStart"
              }
            ],
            "concreteType": "PersonWeekApprovalType",
            "kind": "LinkedField",
            "name": "weekApprovals",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "weekStartYear",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "weekStartMonth",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "weekStartDay",
                "storageKey": null
              },
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "declineReason",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errors",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateApprovalStatusMutation",
    "selections": (v5/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "UpdateApprovalStatusMutation",
    "selections": (v5/*: any*/)
  },
  "params": {
    "cacheID": "a6c62e747ee87968f94f5dbfc02ef96c",
    "id": null,
    "metadata": {},
    "name": "UpdateApprovalStatusMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateApprovalStatusMutation(\n  $input: UpdateApprovalStatusInput!\n  $weekStart: String\n  $weekEnd: String\n) {\n  updateApprovalStatus(input: $input) {\n    timeRegs {\n      id\n      approvalStatus\n      noApprovalStatusChange\n      lockedInPeriod\n    }\n    persons {\n      id\n      submitLockedDateYear\n      submitLockedDateMonth\n      submitLockedDateDay\n      weekApprovals(startDate: $weekStart, endDate: $weekEnd) {\n        id\n        weekStartYear\n        weekStartMonth\n        weekStartDay\n        approvalStatus\n        declineReason\n      }\n    }\n    errors\n  }\n}\n"
  }
};
})();

(node as any).hash = "dd61cae6fd6502169449c28b497c4e62";

export default node;
